import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, SectionLabel } from "./Reveal";

const ABOUT_PHOTO = "/media/about-gallery.webp";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-60">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-12 gap-4 md:gap-16">
          <div className="col-span-12 md:col-span-6 md:col-start-2">
            <Reveal>
              <SectionLabel>{t.about.label}</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="about-heading"
                className="mt-8 font-normal text-3xl md:text-4xl tracking-tight leading-[1.15]"
              >
                {t.about.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.2} className="mt-12 md:mt-14 max-w-xl">
              <p className="text-base md:text-lg leading-relaxed text-foreground/75 tracking-wide">{t.about.p1}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-12 gap-4 md:gap-16 items-center">
          <div className="col-span-12 md:col-span-6">
            <Reveal delay={0.15}>
              <figure data-testid="about-photo">
                <div className="overflow-hidden">
                  <img
                    src={ABOUT_PHOTO}
                    alt={t.altGallery}
                    className="w-full h-auto"
                  />
                </div>
                <figcaption className="mt-4 text-[11px] tracking-[0.12em] text-foreground/45">
                  {t.capGallery}
                </figcaption>
              </figure>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-4 md:col-start-8">
            <Reveal delay={0.25} className="space-y-8">
              <p className="text-base md:text-lg leading-relaxed text-foreground/75 tracking-wide">{t.about.p2}</p>
              <p className="text-base md:text-lg leading-relaxed text-foreground/75 tracking-wide">{t.about.p3}</p>
              <p
                data-testid="about-quote"
                className="border-l border-foreground/40 pl-6 md:pl-8 py-1 my-4 md:my-6 text-lg md:text-xl leading-relaxed text-foreground tracking-wide"
              >
                {t.about.quote}
              </p>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] px-6 md:px-12 mt-24 md:mt-36">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-foreground/50 md:ml-[16.66%]">
            {t.contribute.principlesLabel}
          </p>
        </Reveal>
        <div className="mt-10 md:ml-[16.66%] grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {t.contribute.principles.map((p, i) => (
            <Reveal key={i} delay={0.06 * i}>
              <div data-testid={`principle-${i + 1}`} className="border-t border-foreground/15 pt-8">
                <span className="font-mono text-xs text-foreground/40 tracking-widest">
                  ({String(i + 1).padStart(2, "0")})
                </span>
                <h3 className="mt-4 font-medium text-lg tracking-tight leading-snug">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground/65 tracking-wide">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
